import React from "react";
import { twMerge } from "tailwind-merge";

import { Avatar as placeholder } from "~/common/assets";

export const Avatar = ({
  alt,
  className,
  src,
  ...props
}: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <div
    className={twMerge(
      "aspect-square flex-shrink-0 overflow-hidden rounded-full",
      className,
    )}
  >
    <img alt={alt} src={src ?? placeholder} className="w-full" {...props} />
  </div>
);
